import { GetApp } from "../App"
import { Menu, MenuItemDividerProps } from "./Menu"
import { GetAppView } from "../Views/AppView"
import { AppOverlayContent } from "../Views/AppOverlayContentView"

export interface MenuHelpProps {
  // Opt-in initial open state, forwarded to the underlying `Menu`. Real callers
  // never set this; it exists so catalog fixtures can preview the item list
  // itself, not just the collapsed button (#384).
  initOpen?: boolean;
}

export function MenuHelp({ initOpen }: MenuHelpProps) {
  const app = GetApp();
  const t = app.getT("MenuHelp");
  const { setAppOverlay } = GetAppView();

  return (
    <Menu button={t("title")} global={true} initOpen={initOpen} items={[
      { id: "documentation", onClick: () => {
        window.open(`https://logbook.yachts/site/${app.language}/documentation`, "_blank");
        return true;
      }, title: t("documentation") },

      { id: "demo", onClick: () => {
        window.open(`https://logbook.yachts/site/${app.language}/demos`, "_blank");
        return true;
      }, title: t("demo") },

      { id: "support", onClick: () => {
        window.open(`https://logbook.yachts/site/${app.language}/support`, "_blank");
        return true;
      }, title: t("support") },

      { id: "qanda", onClick: () => {
        window.open(`https://logbook.yachts/site/${app.language}/support#tip`, "_blank");
        return true;
      }, title: t("qanda") },

      MenuItemDividerProps,

      { id: "changelog", onClick: () => {
        setAppOverlay(AppOverlayContent.changeLog);
        return true;
      }, title: t("change_log") },

      { id: "contact_support", onClick: () => {
        window.location.href = "mailto:contact@trimutic.com";
        return true;
      }, title: t("contact_support") },

      MenuItemDividerProps,

      { id: "about", onClick: () => {
        setAppOverlay(AppOverlayContent.about);
        return true;
      }, title: t("about") },
    ]}
    />
  );
}
